import { NewMember, MembershipProductType, FlowType } from '@ace-clublabs/common-membership-api-types';

export interface IGetMembershipStatusResponse {
  status: CreateMembershipStatus[];
  error?: {
    message: string;
  };
}

export interface NewJoinConfirmationData {
  membershipLevel: string;
  firstName: string;
  lastName: string;
  membershipNumber: string;
  effectiveDate: string;
  expirationDate: string;
  confirmationId?: string;
  email?: string;
  paymentDetails?: {
    paymentType: string;
    card?: {
      brand: string;
      last4: string;
      expDate: string;
    };
  };
  members: Pick<NewMember, MemberPublicFields>[];
  options: MembershipProductType[];
  autoPayStatus?: TransactionStatus;
  communicationPreference?: CommunicationPreference;
  amount: string;
  tags?: any;
  appName: FlowType;
  clubCode: string;
}

export type MemberPublicFields = Extract<'roleType' | 'firstName' | 'lastName', keyof NewMember>;

export enum CreateMembershipStatus {
  INITIALIZED = 'INITIALIZED',
  AUTOPAY_ENROLLMENT_FAILED = 'AUTOPAY_ENROLLMENT_FAILED',
  COMPLETED = 'COMPLETED',
  CHARGE_DECLINED = 'CHARGE_DECLINED',
  CARD_NOT_AAA_VISA = 'CARD_NOT_AAA_VISA',
  ACTIVE_MEMBERSHIP_EXISTS = 'ACTIVE_MEMBERSHIP_EXISTS',
  FAILED = 'FAILED',
  FULL_DIGITAL_COMMUNICATION_PREFERENCES_FAILED = 'FULL_DIGITAL_COMMUNICATION_PREFERENCES_FAILED',
  PAPERLESS_BILLING_OPTIN_FAILED = 'PAPERLESS_BILLING_OPTIN_FAILED',
  GROUPON_COUPON_REDEEMED = 'REDEEMED',
  GROUPON_COUPON_EXPIRED = 'EXPIRED',
  GROUPON_COUPON_REFUNDED = 'REFUNDED',
}

export enum AutopayStatus {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
}

export enum CommunicationPreference {
  PAPERLESS = 'PAPERLESS',
  PRINT = 'PRINT',
}

export enum TransactionStatus {
  Initiated = 'initiated', //202
  Processing = 'processing', //202
  Succeeded = 'succeeded', //200
  Failed = 'failed', //402
  Queued = 'queued',
  Error = 'error', //402
  Invalid = 'invalid', //400
  PartialSuccess = 'partial-success', //207
  Exception = 'exception', //500
}
